import p from "../../../../@babel/runtime/helpers/esm/extends.js";
import h from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import d from "./createBreakpoints.js";
import g from "./shape.js";
import x from "./createSpacing.js";
import b from "../styleFunctionSx/styleFunctionSx.js";
import _ from "../styleFunctionSx/defaultSxConfig.js";
import k from "./applyStyles.js";
import s from "../../../utils/esm/deepmerge/deepmerge.js";
const y = ["breakpoints", "palette", "spacing", "shape"];
function P(r = {}, ...i) {
  const {
    breakpoints: a = {},
    palette: m = {},
    spacing: c,
    shape: l = {}
  } = r, t = h(r, y), u = d(a), f = x(c);
  let e = s({
    breakpoints: u,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: p({
      mode: "light"
    }, m),
    spacing: f,
    shape: p({}, g, l)
  }, t);
  return e.applyStyles = k, e = i.reduce((n, o) => s(n, o), e), e.unstable_sxConfig = p({}, _, t?.unstable_sxConfig), e.unstable_sx = function(o) {
    return b({
      sx: o,
      theme: this
    });
  }, e;
}
export {
  P as default
};
